/* Cards can hold a photo or a video.
   Video cards stay perfectly still and only play while hovered (or while touched);
   photo cards keep their tilt/holo animation, which lives in each section's own script. */
(function () {
  var cards = document.querySelectorAll(".has-vid");
  if (!cards.length) return;

  Array.prototype.forEach.call(cards, function (card) {
    var vids = card.querySelectorAll("video");   // blur mode renders a backdrop copy too
    if (!vids.length) return;
    var v = vids[vids.length - 1];               // the visible one is rendered last
    Array.prototype.forEach.call(vids, function (el) {
      el.muted = true;
      el.loop = true;
      el.playsInline = true;
      el.setAttribute("playsinline", "");
      el.removeAttribute("autoplay");
      el.controls = false;
      try { el.pause(); } catch (e) {}
    });

    var playing = false;
    function play() {
      if (playing) return;
      playing = true;
      card.classList.add("vid-playing");
      Array.prototype.forEach.call(vids, function (el) {
        var p = el.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
    function stop() {
      playing = false;
      card.classList.remove("vid-playing");
      Array.prototype.forEach.call(vids, function (el) {
        try { el.pause(); el.currentTime = 0; } catch (e) {}
      });
    }

    var canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    if (canHover) {
      card.addEventListener("pointerenter", play);
      card.addEventListener("pointerleave", stop);
      // stop playing once scrolled away, so nothing runs off screen
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (!en.isIntersecting) stop(); });
        }, { threshold: 0 }).observe(card);
      }
    } else {
      // No hover on a phone, and tap-to-play is easy to miss — so play while the card is
      // actually on screen and stop as soon as it scrolls away.
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) play(); else stop(); });
        }, { threshold: 0.6 }).observe(card);
      } else {
        play();
      }
      // a tap restarts it, in case someone wants to watch it again
      card.addEventListener("touchstart", function () { stop(); play(); }, { passive: true });
    }
  });
})();
